import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Apprenant, InputModel, Person, QResult, QueovalDik, Select } from "../../../../models";
import { Stage } from "../../../../models/formation/formation.model";
import { CoreService, HttpService } from "../../../../services";
import { ToastService } from "../../../../toast";




@Injectable()
export class StageService implements OnDestroy {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    private toast: ToastService
  ) {
  }

  public Stage: Stage;
  public ObjectifPedagogique: string;

  public RefreshEffectif: boolean;

  get Responsable(): Person {
    if (!this.Stage)
      this.Stage = new Stage();
    if (!this.Stage.Responsable)
      this.Stage.Responsable = new Person();
    return this.Stage.Responsable;
  }

  set Responsable(newResponsable: Person) {
    if (!this.Stage)
      this.Stage = new Stage();
    this.Stage.Responsable = newResponsable;
  }

  public GetCursusList(): Observable<QResult<Array<Select>>> {
    return this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_CURSUS/0/`).pipe();
  }

  public GetCursusActifList(): Observable<QResult<Array<Select>>> {
    return this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_CURSUS_ACTIF/0/`).pipe();
  }

  public GetCycleByStage(): Observable<QResult<Select>> {
    return this.http.getHttp<QResult<Select>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_CYCLE_BY_STAGE/${this.Stage.Ident}/`).pipe();
  }

  public GetApprenantsByStageList(): Observable<QResult<Array<Apprenant>>> {
    return this.http.getHttp<QResult<Array<Apprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_APPRENANTS_BY_STAGE/${this.Stage.Ident}/`).pipe();
  }

  public GetStageData(): Observable<QResult<Stage>> {    
    return this.http.getHttp<QResult<Stage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_STAGE_BY_ID_STAGE/${this.Stage.Ident}/`).pipe(
      map((result: QResult<Stage>) => {
        this.Stage = result.Value;

        return result;
      })
    );
  }

  public GetObjectifPedagogique(): Observable<QResult<string>> {
    return this.http.getHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/OBJECTIF_PEDAGOGIQUE/${this.Stage.Ident}/`).pipe(
      map((result: QResult<string>) => {
        this.ObjectifPedagogique = result.Value;
        return result;
      })
    );
  }

  public GetTypesBilan(): Observable<QResult<Array<Select>>> {
    return this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/TYPES_BILAN`).pipe(
      map((result: QResult<Array<Select>>) => {
        return result;
      })
    );
  }

  public GetPropertyStageForBilan(): Observable<QResult<Array<InputModel>>> {
    return this.http.getHttp<QResult<Array<InputModel>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/PROPERTY_STAGE_BILAN/${this.Stage.Ident}/`).pipe(
      map((result: QResult<Array<InputModel>>) => {
        return result;
      })
    );
  }

  public SetRefresh() {
    this.RefreshEffectif = true;
    setTimeout(() => {
      this.RefreshEffectif = false;
    }, 1);
  }

  public ReplaceResponsable(newResponsable: Person): Observable<QResult<boolean>> {
    const model: QueovalDik = new QueovalDik(newResponsable.Id, this.Stage.Ident);
    return this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/INSERT_LIEN_RESPONSABLE_STAGE/`, model).pipe(
      map((result: QResult<boolean>) => {
        if (result.Value) {
          if (!newResponsable.Id) {
            newResponsable.Id = "0";
          }
          this.Responsable = newResponsable;
        }
        return result;
      })
    );
  }

  public ReplaceCycle(pIdCycle: string): Observable<QResult<boolean>> {
    const model: QueovalDik = new QueovalDik(`${pIdCycle}`, this.Stage.Ident);
    return this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/INSERT_LIEN_CYCLE_STAGE/`, model).pipe(
      map((result: QResult<boolean>) => { return result; })
    );
  }
  public GetResponsableByStage(): Observable<QResult<Person>> {
    return this.http.getHttp<QResult<Person>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_RESPONSABLE_BY_STAGE/${this.Stage.Ident}/`).pipe(
      map((result: QResult<Person>) => {
        this.Responsable = result.Value;
        return result;
      })
    );
  }

  public GetNbHoursStage(): Observable<QResult<number>> {
    return this.http.getHttp<QResult<number>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_DUREE_STAGE/${this.Stage.Ident}/`).pipe(
      map((result: QResult<number>) => {
        return result;
      })
    );
  }

  /**
   * Enregistrement des dates du stage
   * @returns
   */
  public SaveDateStage(): Observable<QResult<Stage>> {
    return this.http.postHttp<QResult<Stage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/SAVE_DATE_STAGE/`, this.Stage).pipe(
      map((result: QResult<Stage>) => { return result; })
    );
  }

  public isModeCursus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  

  ngOnDestroy(): void { }
}
